// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"81dfcb75","135":"3acb6f68","261":"d1cfb782","528":"e6616a8b","662":"b1b097e8","670":"2bd19845","798":"e4125617"}[chunkId] + ".chunk.js";
};